
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 25.22 20.75"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Laag 2"}},[_c('path',{attrs:{"d":"M24.93 11.24v-.38a.14.14 0 010-.06.64.64 0 010-.07V10.58a.13.13 0 010-.06 1.41 1.41 0 000-.29.13.13 0 010-.06V10.02a.64.64 0 010-.07.14.14 0 010-.06v-.38l-.1-.11L15.61.43a1.52 1.52 0 00-2.11 0 1.43 1.43 0 000 2.05l6.63 6.44H1.49a1.46 1.46 0 100 2.91h18.64l-6.63 6.44a1.44 1.44 0 000 2.06 1.53 1.53 0 001.06.42 1.51 1.51 0 001-.42l9.18-8.93.1-.1v-.06","fill":"#fff","data-name":"Laag 1"}})])])
          )
        }
      }
    